import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 pl-0" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-produkte_statistik",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "reports list-unstyled mx-auto p-inline-start-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_link_report = _resolveComponent("link-report")!
  const _component_error_message = _resolveComponent("error-message")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.reports.title')), 1)
      ])
    ]),
    _createVNode(_component_link_back, {
      to: "/",
      i18nMessage: "common.backToDashboard"
    }),
    _createVNode(_component_loading_container, { state: _ctx.state }, {
      default: _withCtx(() => [
        (_ctx.reports.length > 0 || _ctx.rooms.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'report-daily-' + index
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'admin-daily-report', params: { id: room.id }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('views.reports.daily', { msg: room.name})), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128)),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'admin-occupancy-report'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('views.reports.occupancy')), 1)
                  ]),
                  _: 1
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (report, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'report-common-' + index
                }, [
                  _createVNode(_component_link_report, { report: report }, null, 8, ["report"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(_component_error_message, {
              key: 1,
              i18nMessage: "views.reports.noReports"
            }))
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}